var map = {
	"./1.png": 55866,
	"./10.png": 14562,
	"./2.png": 64978,
	"./3.png": 73539,
	"./4.png": 36539,
	"./5.png": 88228,
	"./6.png": 19489,
	"./7.png": 47854,
	"./8.png": 85251,
	"./9.png": 57252
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91436;